<template>
    <div>
        <h1 class="page-header">
            {{ $t('studentVehicle.pageTitle') }}
        </h1>
        <ts-card>
            <ts-card-wrapper>
                <div class="d-flex justify-content-between">
                    <div>
                        <ts-button color="info" outline @click="$router.push({ name: 'student-vehicle-create' })">{{
                            $t('add_new') }}</ts-button>
                    </div>
                    <div>
                        <ts-input
                            v-model="search"
                            :placeholder="$t('studentVehicle.search')"
                            style="width: 300px"
                            class="inline-block"
                        />
                    </div>
                </div>
            </ts-card-wrapper>
            <ts-table :columns="columns" :records="resources" :loading="loading">
                <template v-slot="{ record }">
                    <td>{{ record.card_number }}</td>
                    <td>{{ record.first_name_en }}  {{ record.last_name_en }}</td>
                    <td>{{ record.gender }}</td>
                    <td>{{ record.plate_no }}</td>
                    <td>{{ record.name_en }}</td>
                    <td>{{ record.driverGender == 1 ? 'Male' : 'Female' }}</td>
                    <td>{{ record.phone_number_1 }}</td>
                </template>
            </ts-table>
            <div class="d-flex justify-content-end p-15">
                <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
            </div>
        </ts-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
    name: 'student-vehicle',
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState('studentVehicle', ['resources', 'pagination']),
        search: {
            get() {
                return this.$store.state.studentVehicle.search
            },
            set(newValue) {
                this.$store.commit('studentVehicle/SET_SEARCH', newValue)
                this.$store.commit('studentVehicle/RESET_CURRENT_PAGE')
            }
        },
        columns() {
            return [
                {
                    name: this.$t('studentVehicle.cardID')
                },
                {
                    name: this.$t('studentVehicle.studentName')
                },
                {
                    name: this.$t('studentVehicle.sexStudent')
                },
                {
                    name: this.$t('studentVehicle.plateNo')
                },
                {
                    name: this.$t('studentVehicle.driverName')
                },
                {
                    name: this.$t('studentVehicle.sexDriver')
                },
                {
                    name: this.$t('studentVehicle.phoneNumber')
                },
            ]
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        fetchData(attributes) {
            this.loading = true
            this.$store
                .dispatch(
                    'studentVehicle/fetch', attributes
                )
                .then(() => {
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false
                    this.$toasted.error(error.message)
                })
        }
    },
    watch: {
        search: debounce(function(search) {
            this.fetchData({ search })
        }, 500)
    },
}
</script>

